export default "__VITE_ASSET__uaPOMk4p__"